<div class="right-sidebar" [class.visible]="visible">
  <button class="close-btn" (click)="onCloseSidebar()">
    <span class="material-symbols-rounded">close</span>
  </button>
  <div class="sidebar-head">
    <ng-container *ngTemplateOutlet="headTemplate"></ng-container>
  </div>

  <div class="sidebar-content">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
</div>
